import { Outlet, createFileRoute } from '@tanstack/react-router';
import { evaluateModeratorAccess, requireAdminAccess } from '../../../../features/admin';

export const Route = createFileRoute('/_auth/admin/feedback')({
  beforeLoad: requireAdminAccess(evaluateModeratorAccess),
  component: () => <Outlet />,
});
